<script setup lang="ts">
const props = defineProps<{
  themeKeys: {
    text: string;
  };
}>();

const config = useState('CONTENT_CONFIG');

const lang = useLocalStorage('CONTENT_LANG', 'en');

const langChanged = async (event) => {
  lang.value = event.target.value;
};

const selectorOpen = ref(false);
const items = computed(() =>
  Object.entries(config?.value?.langs ?? {}).map(([key, value]) => ({
    label: selectorOpen.value ? value : key.toUpperCase(),
    value: key,
  })),
);
</script>

<template>
  <div
    class="h-full flex flex-row items-center"
    :style="{
      color: props.themeKeys.text,
    }"
  >
    <Icon name="i-lucide-globe" class="size-6" />
    <USelect
      v-model="lang"
      v-model:open="selectorOpen"
      :items="items"
      class="w-20 z-100"
      variant="none"
      :ui="{
        value: `text-lg text-(--ui-text-toned) font-semibold`,
        content: 'min-w-fit'
      }"
      :content="{
        align: 'end',
        side: 'bottom',
      }"
    />
  </div>
</template>
